
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import classnames from 'classnames'

export default class Toast extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
    type: PropTypes.oneOf(['info', 'success', 'warning', 'error'])
  }

  static defaultProps = {
    type: 'success'
  }

  render() {
    const {children, type, onClose, onMouseOver, onMouseOut} = this.props
    const className = classnames('toast', {[`is-${type}`]: type})

    return (
      <div className={className} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
        <div className='toast_message'>{children}</div>
        {onClose ? <Icon className='toast_close' size='12px' name='cross' onClick={onClose} /> : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Toast/index.js